// extracted by mini-css-extract-plugin
module.exports = {"concept-diagram":"index__concept-diagram___3ZPE5","conceptDiagram":"index__concept-diagram___3ZPE5","adaptive":"index__adaptive___2XapZ"};